import { AnthropicAuthSection } from "@/components/agent-anthropic-auth/AnthropicAuthSection";

// #227: Plattformweiter Anthropic-Zugang (admin-only). Gilt für alle Agents ohne
// eigenen per-Agent-Override (den setzt man auf der Agent-Detail-Seite).
export function AnthropicAuthPage() {
  return (
    <div className="max-w-3xl space-y-5">
      <AnthropicAuthSection />
    </div>
  );
}
